var _path, _path2, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 78.5C84.5887 72.1108 103.66 33.803 80.4803 48.0366C57.3008 62.2701 69.0929 28.5162 54.8595 32.583C40.6261 36.6499 47.9255 80.9498 23.5457 67.1502C1.99166 54.9499 19.0125 46.2863 6 40.9995",
    stroke: "#FAF3DD",
    strokeWidth: 1.83
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.47261 39.8359L5.0278 43.4959L8.58299 39.8359C10.5465 37.8146 10.5465 34.5373 8.58299 32.516C6.61951 30.4947 3.43608 30.4947 1.47261 32.516C-0.49087 34.5373 -0.490869 37.8146 1.47261 39.8359ZM3.44769 37.8028L5.0278 39.4295L6.60792 37.8028C7.48059 36.9044 7.48059 35.4478 6.60791 34.5494C5.73524 33.651 4.32036 33.651 3.44768 34.5494C2.57501 35.4478 2.57501 36.9044 3.44769 37.8028Z",
    fill: "#FAF3DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 44.8945,
    r: 2.5,
    fill: "#FAF3DD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 36.8945,
    r: 2.5,
    fill: "#FAF3DD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 61.5,
    r: 2.5,
    fill: "#FAF3DD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 79,
    r: 5,
    fill: "#FAF3DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.8522f1373f33fbaa0de6b0d2b3cc5f4f.svg";
export { ForwardRef as ReactComponent };